import { SpacingUI } from "./SpacingUI";

type Props = {
  size?: 1 | 2 | 3 | 4;
};

export function Spacing1() {
  return <Spacing size={1} />;
}

export function Spacing2() {
  return <Spacing size={2} />;
}

export function Spacing3() {
  return <Spacing size={3} />;
}

export function Spacing4() {
  return <Spacing size={4} />;
}

function Spacing({ size = 3 }: Props) {
  return <SpacingUI size={size} />;
}
